import Layout from '../../../components/Layout';
import TicketViewContent from '../../../components/Pages/Tickets/[ticketId]';
import Menu from '../../../components/Layout/Menu';

export default function TicketView(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Ticket View page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <TicketViewContent />
    </Layout>
  );
}
